import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { toast } from 'sonner';
import { ensureConversationForSource } from '../../../api/conversations.service';

/** "Responder" a un bug = abrir su hilo y saltar al chat de Conversaciones. */
const ReplyBugModal = ({ visible, setVisible, selectedBug }) => {
    const history = useHistory();

    useEffect(() => {
        if (!visible || !selectedBug?._id) return;
        let cancelled = false;
        (async () => {
            try {
                const resp = await ensureConversationForSource({
                    userId: selectedBug?.createdBy?._id,
                    source: 'bug',
                    sourceId: selectedBug?._id,
                    originalText: selectedBug?.reason,
                });
                if (cancelled) return;
                if (resp?.data?._id) history.push(`/conversations/${resp.data._id}`);
                else toast.error('No se pudo abrir la conversación');
            } catch (e) {
                if (!cancelled) toast.error('No se pudo abrir la conversación');
            } finally {
                if (!cancelled) setVisible(false);
            }
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, selectedBug?._id]);

    return null;
};

export default ReplyBugModal;
